import Tabs from "components/lib/Shared/Tabs";
import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CompanySummary from "./CompanySummary";
import GovernanceSummary from "./GovernanceSummary";
import { companySummaryValidation } from "./CompanySummary/validation";

const summary = ({ goToNextTab, partialData }) => {
  const { createdCompany } = useSelector(
    (state) => state.transferYourBusinessSlice
  );
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [isCompanySummaryValid, setIsCompanySummaryValid] = useState(false);

  const tabs = useMemo(
    () => [
      {
        id: "company",
        label: "1. Company Summary",
      },
      {
        id: "governance",
        label: "2. Governance Summary",
        disabled: !isCompanySummaryValid,
      },
    ],
    [isCompanySummaryValid]
  );

  const handleCompanySummaryValidityChange = useCallback((isValid) => {
    setIsCompanySummaryValid(isValid);
  }, []);

  const isLastStep = selectedTabIndex === tabs.length - 1;
  const isFirstStep = selectedTabIndex === 0;

  const goToPreviousStep = () => {
    if (!isFirstStep) {
      setSelectedTabIndex(selectedTabIndex - 1);
    }
  };

  const goToNextStep = () => {
    if (!isLastStep) {
      setSelectedTabIndex(selectedTabIndex + 1);
    }
    if (isLastStep) {
      goToNextTab();
    }
  };

  return (
    <>
      <Tabs
        tabs={tabs}
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
        showBorderBottom={false}
      />
      <div>
        {selectedTabIndex === 0 ? (
          <CompanySummary
            partialData={partialData}
            goToNextStep={goToNextStep}
            onValidityChange={handleCompanySummaryValidityChange}
          />
        ) : (
          <>
            <GovernanceSummary
              goToNextStep={goToNextStep}
              goToPreviousStep={goToPreviousStep}
            />
          </>
        )}
      </div>
    </>
  );
};

export default summary;
